// extracted by mini-css-extract-plugin
export default {"link":"LinkBack_link__bMS1X","link__img":"LinkBack_link__img__Yw8Ys"};